<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
  @import './assets/style/vant-taojin-ticket.css';
  @import './assets/style/element-taojin-ticket.css';
</style>


// WEBPACK FOOTER //
// src/App.vue